import axios from "axios";
import {BASE_API_URL} from "../../app/AppConfig";
import {Product, ProductDetailOption} from "../Entity/Product";
import {LocalParams} from "../../components/LocalParams";

export async function getProductBySlugRep(slug: string): Promise<Product> {
  try {
    const userToken = LocalParams.getItem("token");

    const response = await axios.get<Product>(
      `${BASE_API_URL}/products-by-slug/${slug}`,
      userToken ? {headers: {Authorization: 'Bearer ' + userToken}} : undefined
    );
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }

}

export async function getProductOptionsRep(productSlug: string, locale: string): Promise<ProductDetailOption[]> {
  try {
    const response = await axios.get<ProductDetailOption[]>(
      `${BASE_API_URL}/product/${productSlug}/options?locale=${locale}`,
    );
    return response.data;
  } catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}
